// extracted by mini-css-extract-plugin
module.exports = {"root":"OurProducts_root__hsgee","root_container":"OurProducts_root_container__PdX1S","root_container_line":"OurProducts_root_container_line__ImOGD"};